import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { ICellEditorParams } from 'ag-grid-community'
import { CustomEnumValue } from '../../../../../lib/commons/appFunction'
import { StatusComboBox } from '../../../../../view/components/comboBox/StatusComboBox'
import { filterValuesByCombination } from '../../../../../lib/commons/customEnum'
import objects from '../../../../../utils/objects'
import { ProgressIcon } from '../../../commons/AgGrid/components/cell/custom/wbsItemStatus/ProgressIcon'
import {
  ProgressIconArea,
  StatusRootDiv,
} from '../cellRenderer/WbsItemStatusCellRenderer'
import usePrevious from '../../../../hooks/usePrevious'

interface Props extends ICellEditorParams {
  customEnumCode?: string
  combinedValuePath?: (combinedEnumCode: string) => string
  valuesAllowed?: CustomEnumValue[]
  popperOpen?: boolean
}

export const WbsItemStatusCellEditor = forwardRef(
  (
    { customEnumCode, combinedValuePath, value, api, context, data }: Props,
    ref
  ) => {
    const [val, setVal] = useState(value ?? '')
    const wbsItem = data?.body?.wbsItem ?? data?.wbsItem

    let options: CustomEnumValue[] = []
    if (customEnumCode) {
      options = filterValuesByCombination(context[customEnumCode], code =>
        objects.getValue(data, combinedValuePath?.(code))
      )
    }

    useImperativeHandle(ref, () => ({
      getValue() {
        return val
      },
    }))

    const prevVal = usePrevious(val)
    useEffect(() => {
      if (val && prevVal && val !== prevVal) {
        api.stopEditing()
      }
    }, [api, val, prevVal])

    if (!options) return <></>

    return (
      <StatusRootDiv>
        <ProgressIconArea>
          <ProgressIcon wbsItem={wbsItem} fontSize={20} />
        </ProgressIconArea>
        <StatusComboBox
          value={val}
          options={options}
          dropDownListOpen={true}
          onChange={newValue => {
            setVal(newValue)
          }}
          onClick={() => {
            api.stopEditing()
          }}
        />
      </StatusRootDiv>
    )
  }
)
